import type { InterviewConsentPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewConsentFetched';

export type InterviewConsentWithdrawnAction = {
	type: 'INTERVIEW_CONSENT_WITHDRAWN';
	payload: InterviewConsentPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
	interviewId: number;
};

export default (
	payload: InterviewConsentPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
	interviewId: number,
): InterviewConsentWithdrawnAction => ({
	type: 'INTERVIEW_CONSENT_WITHDRAWN',
	payload,
	facilityId,
	typeKey,
	subjectId,
	interviewId,
});
